import { useMemo } from 'react'

import { SimilarListingsQuery, SimilarListingsQueryVariables } from '../../api/gqlaxy/gql/generated/graphql'
import { ErrorPrompt, OptionQuery } from '../../types/error'
import { QueryKey } from '../../constants/queryKey'
import { graphqlGLClient } from '../../api/gqlaxy/gql/queries/graphQLClient'
import { useSimilarListingsQuery } from '../../api/gqlaxy/gql/generated/graphql-hooks'
import { useGQLErrorHandler } from '..'

const localErrorPrompts: ErrorPrompt[] = [
  {
    error: 'similarListings-listingNotFound',
    disableErrorPrompts: true
  }
]

export const useGetSimilarListings = (
  param: SimilarListingsQueryVariables,
  option: OptionQuery<SimilarListingsQuery>
) => {
  const client = graphqlGLClient({
    // endpoint: 'http://127.0.0.1:5001/mobile-staging-376418/us-central1/gqlactus' // local endpoint
  })

  const { disableErrorPrompts, errorPrompts = [], ...options } = option

  const combinedErrorPrompts = useMemo(() => [...localErrorPrompts, ...errorPrompts], [errorPrompts])

  const handleError = useGQLErrorHandler({ disableErrorPrompts, errorPrompts: combinedErrorPrompts })

  return useSimilarListingsQuery(client, param, {
    queryKey: [QueryKey.GetSimilarListings, param.input],
    onError: handleError,
    ...options
  })
}
